jQuery(document).ready( function($) {
    
    // New Events 
    var   debug = false;
    var   $body = $(document.body);
    
    // Phone and Text Clicks
    $('a[href^="tel:"], a[href^="sms:"]').click(function() { 
        if(debug == true) { 
            console.log("LinkedIn event - Contact, tracked");
        } else { 
            var eventObject = document.createElement('img');
            eventObject.width  = '1';
            eventObject.height = '1';
            eventObject.height = '1';
            eventObject.alt = '';
            eventObject.style.display = 'none';
            eventObject.src = "https://px.ads.linkedin.com/collect/?pid=39506&conversionId=1587482&fmt=gif";
            $body.append(eventObject);
            //console.log(eventObject);
        }
    });


    // Contact Submissions: SubmitApplication
    var contactForm = $('#gform_3');
    contactForm.submit( function(event) {
        event.preventDefault();

        var form = this;
        
        if(debug == true) { 
            console.log("LinkedIn event - Contact, tracked");
        
        } else { 
            var eventObject = document.createElement('img');
            eventObject.width  = '1';
            eventObject.height = '1';
            eventObject.height = '1';
            eventObject.alt = '';
            eventObject.style.display = 'none';
            eventObject.src = "https://px.ads.linkedin.com/collect/?pid=39506&conversionId=1587482&fmt=gif";
            $body.append(eventObject);
            //console.log(eventObject);
        }
        setTimeout( function () { 
            form.submit();
        }, 200);
    });    
    
    
    // Career Submissions: SubmitApplication
    var careersForm = $('#gform_3');
    careersForm.submit( function(event) {
        event.preventDefault();

        var form = this;
        
        if(debug == true) { 
            console.log("LinkedIn event - SubmitApplication, tracked");
        
        } else { 
            var eventObject = document.createElement('img');
            eventObject.width  = '1';
            eventObject.height = '1';
            eventObject.height = '1';
            eventObject.alt = '';
            eventObject.style.display = 'none';
            eventObject.src = "https://px.ads.linkedin.com/collect/?pid=39506&conversionId=1587474&fmt=gif";
            $body.append(eventObject);
            //console.log(eventObject);
        }
        setTimeout( function () { 
            form.submit();
        }, 200);
    });
    
    
    
    // Schedule / Quote Form: Schedule / Lead
	var quoteForm = $( '#gform_2' );
	quoteForm.submit( function(event) {
        event.preventDefault();

        var form = this;
        
        if(debug == true) { 
            if( $(this).hasClass('form-schedule-service') ) {
                console.log("LinkedIn event - Schedule, tracked");
            } else {
                console.log("LinkedIn event - Lead, tracked");
            }
        
        } else { 
            if( $(this).hasClass('form-schedule-service') ) {
                var eventObject = document.createElement('img');
                eventObject.width  = '1';
                eventObject.height = '1';
                eventObject.height = '1';
                eventObject.alt = '';
                eventObject.style.display = 'none';
                eventObject.src = "https://px.ads.linkedin.com/collect/?pid=39506&conversionId=1587490&fmt=gif";
                $body.append(eventObject);
                //console.log(eventObject);

            } else {
                var eventObject = document.createElement('img');
                eventObject.width  = '1';
                eventObject.height = '1';
                eventObject.height = '1';
                eventObject.alt = '';
                eventObject.style.display = 'none';
                eventObject.src = "https://px.ads.linkedin.com/collect/?pid=39506&conversionId=1587466&fmt=gif";
                $body.append(eventObject);
                //console.log(eventObject);

            }

        }
        
        setTimeout( function () { 
            form.submit();
        }, 200);
	});
    
    
    
    // Event Continue Form: CompleteRegistration
    var continueEvent = $( '.ga-event-signup' );
    continueEvent.click( function(event) {
        event.preventDefault();

        var button = $(this);

        if(debug == true) { 
            console.log("LinkedIn event - CompleteRegistration, tracked");
        
        } else { 
            var eventObject = document.createElement('img');
            eventObject.width  = '1';
            eventObject.height = '1';
            eventObject.height = '1';
            eventObject.alt = '';
            eventObject.style.display = 'none';
            eventObject.src = "https://px.ads.linkedin.com/collect/?pid=39506&conversionId=1587458&fmt=gif";
            $body.append(eventObject);
            //console.log(eventObject);
        }
        
        setTimeout( function () { 
            window.open( button.attr('href') , '_blank');
        }, 200);
    });


});